import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const scrollToOrder = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('order-bump')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/oh1Bj9hNy3YgG8oLZznuFH/PACK_IMPRIMIBLE.png',
    title: 'Pack imprimible: clases listas en 1 minuto',
    items: ['Actividades listas para imprimir', 'Uso inmediato'],
    benefit: 'Ideal para cuando no tenés tiempo'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/nwvURNDGctU7zy5C4rBKNM/SISTEMA_DE_ORGANIZACION.png',
    title: 'Sistema de organización docente sin estrés',
    items: ['Planificación', 'Seguimiento del año', 'Control total'],
    benefit: 'Vas a dejar de improvisar'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/pP5cdK5q9TSRsGzrTKyEN2/KIT_DE_ACTIVIDADES.png',
    title: 'Kit de actividades express para el aula',
    items: ['Actividades rápidas', 'Inicio, desarrollo y cierre', 'Dinámicas listas'],
    benefit: 'Perfecto para salvar clases'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/e9nHDY7jurpmi11BRmF29C/KIT_VISUAL.png',
    title: 'Kit visual para explicar matemática fácil',
    items: ['Recursos visuales', 'Apoyo para explicar mejor', 'Claridad conceptual'],
    benefit: 'Tus alumnos van a entender más rápido'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/pxxAr9FF4j5Q2HAquMtEGe/SISTEMA_DE_REFUERZO_Y_REPASO.png',
    title: 'Sistema de refuerzo y repaso inteligente',
    items: ['Práctica adicional', 'Refuerzo progresivo', 'Consolidación de contenidos'],
    benefit: 'Asegurás el aprendizaje real'
  }];
  return <section className="py-12 px-6 bg-[#0f0f23]" data-id="element-30">
      <div className="text-center mb-10" data-id="element-31">
        <div className="inline-flex items-center justify-center p-3 bg-yellow-500/20 rounded-full mb-4" data-id="element-32">
          <Gift className="w-8 h-8 text-yellow-400" data-id="element-33" />
        </div>
        <h2 className="text-2xl font-black text-white mb-2 leading-tight" data-id="element-34">
          🎁 HOY TE LLEVÁS TODOS ESTOS REGALOS GRATIS
        </h2>
        <p className="text-gray-400 text-sm" data-id="element-35">
          Además, accedés a toda la biblioteca de herramientas:
        </p>
      </div>

      <div className="space-y-8" data-id="element-36">
        {bonuses.map((bonus, index) => <div key={index} className="bg-white/5 border border-yellow-500/20 rounded-2xl overflow-hidden" data-id="element-37">
            {/* Large Clickable Image */}
            <div className="w-full flex justify-center bg-white/[0.03] py-8 px-4 cursor-pointer" onClick={scrollToOrder} data-id="element-38">
              <img src={bonus.image} alt={bonus.title} className="h-96 w-auto max-w-full object-contain drop-shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-39" />
            </div>

            {/* Content */}
            <div className="p-5" data-id="element-40">
              <h3 className="font-bold text-white mb-3 text-base leading-tight" data-id="element-41">
                🎁 {bonus.title}
              </h3>

              <ul className="space-y-1.5 mb-3" data-id="element-42">
                {bonus.items.map((item, i) => <li key={i} className="text-gray-400 text-sm flex items-center gap-2" data-id="element-43">
                    <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full shrink-0" data-id="element-44" />
                    {item}
                  </li>)}
              </ul>

              <p className="text-yellow-400 text-sm font-semibold bg-yellow-500/10 inline-block px-3 py-1.5 rounded-lg" data-id="element-45">
                👉 {bonus.benefit}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}